export default __webpack_public_path__ + "Src/Client/Layout/MobileMenu/mobileMenu.html";